exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".buildingBlock {\r\n  position: relative;\r\n  margin: 0.25rem 0.25rem;\r\n  list-style: none;\r\n  cursor: pointer;\r\n  transition: background 0.2s cubic-bezier(0.075, 0.82, 0.165, 1);\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n}\r\n.buildingBlock .delete {\r\n  color: #555;\r\n}\r\n.buildingBlock.jtk-drag {\r\n  opacity: 0.5;\r\n}", ""]);

// exports
